import type { Configuration } from '@api-client/configuration'
import { useCallback } from 'react'

import { useDataFederationConfig } from './useApi'

const EMPTY_CONFIG: Partial<Configuration> = {} as const

export const useAsyncApi = <Api>(
	factory: (config?: Configuration) => Api,
	config: Partial<Configuration> = EMPTY_CONFIG
) => {
	const dataFederationConfig = useDataFederationConfig(config)

	const callWithApi = useCallback(
		<T>(fn: (api: Api) => Promise<T>): Promise<T> => {
			const api = factory(dataFederationConfig)
			return fn(api)
		},
		[factory, dataFederationConfig]
	)
	return callWithApi
}
